import { render, staticRenderFns } from "./TicketComponent.vue?vue&type=template&id=ac88a0ce&"
import script from "./TicketComponent.vue?vue&type=script&lang=ts&"
export * from "./TicketComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TicketComponent.vue?vue&type=style&index=0&id=ac88a0ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports